module.exports = __webpack_public_path__ + "img/MENU_credit-card-white.838d16b5.svg";